<script>
  export let name;
  export let status;
</script>

<div class="diff-entry source {status}">
  <div class="name">{name}</div>
  <div class="details">
    <slot></slot>
  </div>
</div>

<style>
  .diff-entry {
    background: white;
    border-radius: 10px;
    color: #666;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-bottom: 0.5em;
    padding: 0.5em;
  }

  .diff-entry .name {
    font-weight: bold;
    margin-bottom: 0.25em;
    padding: 0.25em;
  }

  .diff-entry.remove .name {
    background-color: #ffbbbb;
  }

  .diff-entry.add .name {
    background-color: #bbffbb;
  }

  .diff-entry.move .name {
    background-color: #ffc862;
  }
</style>
